// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__1DFyU","thumbnail":"item_thumbnail__1SQhN","data":"item_data__1yF8r","category":"item_category___Ge_5","title":"item_title__2raSh","date":"item_date__2jBZt"};